import * as R from 'ramda'
import api from 'shared/api'

export const doLoadGroups = async props => {
  const { type, page } = props
  const {
    data: list,
    headers: { 'x-total-results': total },
  } = await api.get(`/public/groups/feed?type=${type}&page=${page}&limit=20`)

  return {
    list,
    total,
  }
}

export const loadTags = async ({ accessToken, name }) => {
  if (!name) {
    return { list: [] }
  }
  const { data: list } = await api.get(`/tags?name=${name}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })

  return { list }
}

const uploadImage = async ({ imageSrc, accessToken }) => {
  const { data: postData } = await api.post('/upload/image', null, {
    headers: { Authorization: `Bearer ${accessToken}` },
  })

  const formData = new FormData()

  formData.append('file', imageSrc)

  await api.post(postData?.postUrl, formData)

  return postData?.id
}

export const createGroup = async ({ accessToken, values }) => {
  const imageSrc = R.head(values.image || [])
  const image = imageSrc && (await uploadImage({ imageSrc, accessToken }))
  const response = await api.post(
    '/groups',
    { ...values, image, tags: R.pluck('id', values?.tags) },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  )

  return response
}
